module.exports = __webpack_public_path__ + "static/media/notification.2e68085a.svg";